import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const evidenceEnforcementControlStyleId = 'ui-evidence-enforcement-control-theme';

export const evidenceEnforcementControlBridgeStyles = {
  'evidence-enforcement-control': {
    '--local-evidence-enforcement-row-gap': tokens.spacing.sm,
    '--local-evidence-enforcement-column-gap': tokens.spacing.lg,
    '--local-evidence-enforcement-label-color': tokens.color.text.secondary,
    '--local-evidence-enforcement-label-size': tokens.font.size.textSm,
  },
};
